import React, { Component } from 'react';
import axios from 'axios';
import { Configurations } from '../../Utils/Configurations';
import moment from 'moment';
// import Session from '../../Utils/Session';
import 'react-table/react-table.css';
import {
    // UncontrolledTooltip,
    Modal, ModalBody, ModalHeader, ModalFooter, Button,
} from 'reactstrap';
import './Phrase-of-the-Day.scss';
import ErrorModal from '../../Components/ErrorModal/ErrorModal';
import Pagination from 'rc-pagination';
import qs from 'qs';
// import incentivoDia1 from '../../Assets/Images/incentivo-dia-1-capa.jpg';
// import incentivoDia2 from '../../Assets/Images/incentivo-dia-2-capa.jpg';
// import incentivoDia3 from '../../Assets/Images/incentivo-dia-3-capa.jpg';
// import incentivoDia4 from '../../Assets/Images/incentivo-dia-4-capa.jpg';
// import incentivoDia5 from '../../Assets/Images/incentivo-dia-5-capa.jpg';
// import incentivoDia6 from '../../Assets/Images/incentivo-dia-6-capa.jpg';
// import incentivoDia7 from '../../Assets/Images/incentivo-dia-7-capa.jpg';
// import incentivoDia8 from '../../Assets/Images/incentivo-dia-8-capa.jpg';
// import incentivoDia9 from '../../Assets/Images/incentivo-dia-9-capa.jpg';
// import incentivoDia10 from '../../Assets/Images/incentivo-dia-10-capa.jpg';
// import incentivoDia11 from '../../Assets/Images/incentivo-dia-11-capa.jpg';
// import incentivoDia12 from '../../Assets/Images/incentivo-dia-12-capa.jpg';
// import incentivoDia13 from '../../Assets/Images/incentivo-dia-13-capa.jpg';
// import incentivoDia14 from '../../Assets/Images/incentivo-dia-14-capa.jpg';
// import incentivoDia15 from '../../Assets/Images/incentivo-dia-15-capa.jpg';

class PhrasesList extends Component {
    constructor() {
        super();

        this.selecionaFrase = this.selecionaFrase.bind(this);
        this.refreshTableFrases = this.refreshTableFrases.bind(this);
        this.toggleModalExcluir = this.toggleModalExcluir.bind(this);
        this.excluirFrase = this.excluirFrase.bind(this);
        this.handleError = this.handleError.bind(this);
        this.closeErrorModal = this.closeErrorModal.bind(this);
        this.onChangePage = this.onChangePage.bind(this);
        this.carregaFrase = this.carregaFrase.bind(this);

        this.Configurations = new Configurations();

        this.state = {
            naoCarregaFrases: false,
            isLoadingFrases: true,
            listaFrases: [],
            modalExcluirFrase: false,
            isLoadingExcluirFrase: false,
        };

        this.imagensFundo = [
            {
                value: 1,
                src: `https://meubs.com.br/bs-mais/fundos-incentivo/incentivo-dia-1-capa.jpg`,
                alt: "folhagem verde"
            },
            {
                value: 2,
                src: `https://meubs.com.br/bs-mais/fundos-incentivo/incentivo-dia-2-capa.jpg`,
                alt: "onda roxa"
            },
            {
                value: 3,
                src: `https://meubs.com.br/bs-mais/fundos-incentivo/incentivo-dia-3-capa.jpg`,
                alt: "pôr do sol no mar",
            },
            {
                value: 4,
                src: `https://meubs.com.br/bs-mais/fundos-incentivo/incentivo-dia-4-capa.jpg`,
                alt: "fundo rosa com flor",
            },
            {
                value: 5,
                src: `https://meubs.com.br/bs-mais/fundos-incentivo/incentivo-dia-5-capa.jpg`,
                alt: "árvores e céu azul"
            },
            {
                value: 6,
                src: `https://meubs.com.br/bs-mais/fundos-incentivo/incentivo-dia-6-capa.jpg`,
                alt: "grama e céu azul"
            },
            {
                value: 7,
                src: `https://meubs.com.br/bs-mais/fundos-incentivo/incentivo-dia-7-capa.jpg`,
                alt: "céu roxo"
            },
            {
                value: 8,
                src: `https://meubs.com.br/bs-mais/fundos-incentivo/incentivo-dia-8-capa.jpg`,
                alt: "céu colorido"
            },
            {
                value: 9,
                src: `https://meubs.com.br/bs-mais/fundos-incentivo/incentivo-dia-9-capa.jpg`,
                alt: "fundo verde"
            },
            {
                value: 10,
                src: `https://meubs.com.br/bs-mais/fundos-incentivo/incentivo-dia-10-capa.jpg`,
                alt: "cidade com céu colorido"
            },
            {
                value: 11,
                src: `https://meubs.com.br/bs-mais/fundos-incentivo/incentivo-dia-11-capa.jpg`,
                alt: "fundo azul com flores"
            },
            {
                value: 12,
                src: `https://meubs.com.br/bs-mais/fundos-incentivo/incentivo-dia-12-capa.jpg`,
                alt: "uma árvore e céu azul"
            },
            {
                value: 13,
                src: `https://meubs.com.br/bs-mais/fundos-incentivo/incentivo-dia-13-capa.jpg`,
                alt: "folha e fundo verde"
            },
            {
                value: 14,
                src: `https://meubs.com.br/bs-mais/fundos-incentivo/incentivo-dia-14-capa.jpg`,
                alt: "barco a vela no mar"
            },
            // {
            //     value: 15,
            //     src: incentivoDia15,
            //     alt: "fundo branco e azul"
            // },
            {
                value: 15,
                src: `https://meubs.com.br/bs-mais/fundos-incentivo/incentivo-dia-15-whatsapp.jpg`,
                alt: "fundo branco e azul"
            },
            {
                value: 17,
                src: `https://meubs.com.br/bs-mais/fundos-incentivo/incentivo-dia-17-whatsapp.jpg`,
                alt: "novo layout amarelo"
            },
            {
                value: 18,
                src: `https://meubs.com.br/bs-mais/fundos-incentivo/incentivo-dia-18-whatsapp.jpg`,
                alt: "novo layout azul"
            },
            {
                value: 19,
                src: `https://meubs.com.br/bs-mais/fundos-incentivo/incentivo-dia-19-whatsapp.jpg`,
                alt: "novo layout verde"
            },
            {
                value: 20,
                src: `https://meubs.com.br/bs-mais/fundos-incentivo/incentivo-dia-20-whatsapp.jpg`,
                alt: "novo layout laranja"
            },

        ];

    }
    componentDidMount() {
        this.carregaFrase();
    }

    componentWillMount() {
        //implementar verificação de permissão

        // this.inicializaParametros(false);
    }

    carregaFrase() {
        const values = qs.parse(window.location.search),
            limite = parseInt(values.limite, 10) || 10,
            pagina = parseInt(values["?pagina"], 10) || 1;
        const _frases = axios.get(this.Configurations.apiBasePath + `/frase-do-dia/lista?pagina=${pagina}&limite=${limite}`);
        _frases.then(response => {
            this.setState({
                listaFrases: response.data.frases,
                paginasFrases: response.data.paginacao.totalPaginas,
                limite: limite,
                pagina: pagina
            });
        }).catch(this.handleError).finally(() => this.setState({ isLoadingFrases: false }));
    }

    refreshTableFrases(o) {
        this.carregaFrases(o);
    }

    selecionaFrase(_idFrase) {
        this.props.history.push(`detalhes/${_idFrase}`)
    }

    toggleModalExcluir(id, dtFrase) {
        const _toOpen = !this.state.modalExcluirFrase;
        this.setState({
            idFraseExcluir: _toOpen ? id : '',
            dtFraseExcluir: _toOpen ? dtFrase : ''
        }, () => this.setState({ modalExcluirFrase: !this.state.modalExcluirFrase }))
    }

    excluirFrase() {
        this.setState({ isLoadingExcluirFrase: true }, () => {
            axios.delete(this.Configurations.apiBasePath + `/frase-do-dia/${this.state.idFraseExcluir}`).then(response => {
            }).catch(this.handleError).finally(() => this.setState({ isLoadingExcluirFrase: false }, () => {
                this.toggleModalExcluir();
                this.carregaFrase();
            }))
        })
    }

    handleError(err) {
        this.setState({ hasError: true, errorMessage: err.response.data.message })
    }

    closeErrorModal() { this.setState({ hasError: false, errorMessage: "" }) }

    onChangePage(page) {
        this.setState({
            pagina: page,
        }, () => {
            this.props.history.push({ pathname: `/frase-do-dia/lista`, search: `?pagina=${this.state.pagina}&limite=${this.state.limite}` })
        });
    }

    render() {
        return (

            <div className="row frase-do-dia lista-frases">
                <div className="col-12">
                    <div className="row align-items-center">
                        <div className="col-12 text-center col-lg-8 text-lg-left">
                            <h2 className="d-none d-lg-block">Lista de Frases do Dia</h2>
                            <h3 className="d-lg-none">Lista de Frases do Dia</h3>
                        </div>
                        <div className="col-12 text-center col-lg-4 text-right">
                            <button onClick={() => this.props.history.push(`detalhes/nova-frase`)} className="btn btn-outline-info">Cadastrar nova frase</button>
                        </div>

                        <div className={`col-12 text-center text-lg-left`}>
                            <p className="py-2 m-0">Clique na frase para obter mais detalhes e/ou fazer alterações.</p>
                        </div>
                        <div className="col-12 text-center">
                            {this.state.isLoadingFrases ? (
                                <div className="spinner-border text-primary" role="status" />
                            ) : (
                                <ul className="lista-frases-mob px-0">
                                    {!!this.state.listaFrases.length > 0 && this.state.listaFrases.map((item, index) => {
                                        return <li
                                            className="py-2"
                                            key={`frase-${index}`}
                                        >
                                            {/* Layout desktop */}
                                            <div className="card rounded border border-secondary p-2 d-lg-block d-none">
                                                <div className="row">
                                                    <div className="col-12">
                                                        <div className="row align-items-center">
                                                            <div className="col-2">
                                                                <p className="m-0">{moment(item.dtFrase).format("DD/MM/YY")}</p>
                                                            </div>
                                                            <div className="col-1">
                                                                <div className={`phrase-container background-imagem-frase`} style={{ backgroundImage: `url(${this.imagensFundo.filter(imagem => imagem.value === (item.tipoFundo || 15))[0].src})` }}></div>
                                                            </div>
                                                            <div className="col-6 pointer">
                                                                <p onClick={() => this.selecionaFrase(item._id)} className="m-0 font-frase-desktop">{item.frase.replace(/<[^>]*>/g, ' ').replace(/(\r\n|\n|\r)/gm, " ").replace(/&nbsp;/g, '')}</p>
                                                            </div>
                                                            <div className="col-2">
                                                                <span className={`badge badge-${item.habilitado ? 'success' : 'secondary'}`}>{item.habilitado ? 'Habilitada' : 'Desabilitada'}</span>
                                                            </div>
                                                            <div className="col-1 text-right pointer">
                                                                <i onClick={() => this.toggleModalExcluir(item._id, item.dtFrase)} className="text-danger far fa-trash-alt px-2"></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Layout mobile */}
                                            <div className="card rounded border border-info p-2 d-lg-none">
                                                <div className="row no-gutters px-2">
                                                    <div className="col-12">
                                                        <div className="row align-items-center">
                                                            <div className="col-4 text-left data-frase">
                                                                <p className="m-0 ">{moment(item.dtFrase).format("DD/MM/YY")}</p>
                                                            </div>
                                                            <div className="col-8 text-right">
                                                                <i onClick={() => this.toggleModalExcluir(item._id, item.dtFrase)} className="text-danger far fa-trash-alt px-2"></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-12">
                                                        <div className="row align-items-center">
                                                            <div className="col-3">
                                                                <div className={`phrase-container background-imagem-frase`} style={{ backgroundImage: `url(${this.imagensFundo.filter(imagem => imagem.value === (item.tipoFundo || 15))[0].src})` }}></div>
                                                            </div>
                                                            <div className="col-9 frase-mobile">
                                                                <p onClick={() => this.selecionaFrase(item._id)} className="m-0 font-frase py-3"> {item.frase.replace(/<[^>]*>/g, ' ').replace(/(\r\n|\n|\r)/gm, " ").replace(/&nbsp;/g, '')}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    })}
                                </ul>
                            )}
                        </div>
                    </div>
                    {!this.state.isLoadingFrases && this.state.listaFrases && this.state.listaFrases.length > 0 && (
                        <div className="col-12 col-lg-12 bg-white px-0">
                            <div className="paginacao-frases">
                                <Pagination onChange={this.onChangePage} current={this.state.pagina} total={this.state.paginasFrases * this.state.limite} pageSize={this.state.limite} />
                            </div>
                        </div>
                    )}
                </div>
                <Modal isOpen={this.state.modalExcluirFrase} toggle={() => this.toggleModalExcluir(null)}>
                    <ModalHeader toggle={() => this.toggleModalExcluir(null)}>Excluir Frase</ModalHeader>
                    <ModalBody>
                        <p className="m-0">Tem certeza que deseja excluir a <strong>Frase Do Dia de {moment(this.state.dtFraseExcluir).format("DD/MM/YY")}</strong>? Essa operação não poderá ser desfeita.</p>
                    </ModalBody>
                    <ModalFooter>
                        {this.state.isLoadingExcluirFrase ? (
                            <div className="spinner-border text-primary" role="status" />
                        ) : (
                            <Button disabled={this.state.isLoadingExcluirFrase} color='danger' onClick={this.excluirFrase}>excluir</Button>
                        )}
                        {' '}<Button color="secondary" onClick={() => this.toggleModalExcluir(null)}>voltar</Button>
                    </ModalFooter>
                </Modal>
                <ErrorModal
                    isOpen={this.state.hasError}
                    message={this.state.errorMessage}
                    closeErrorModal={this.closeErrorModal}
                    goBack={false}
                />
            </div>
        )
    }
}

export default PhrasesList;
